import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ palette }) => ({
  header: {
    fontSize: "20px",
    lineHeight: 1.25,
    fontWeight: 400,
    color: palette.contrastText.main,
  },
  modalTitle: {
    textAlign: "center",
    fontWeight: 400,
    marginBottom: 0,
  },
  modalRoot: {
    width: 480,
  },
}));

export default styles;
